// Vollea — Notification bell for super_admin (currently surfaces unread
// beta feedback count). Polls /api/admin/stats every 30s while mounted, so
// new feedback shows up without a page refresh. Click navigates straight to
// the feedback inbox; the badge naturally clears once items are resolved
// because feedback_new only counts status="new".
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IoNotifications, IoNotificationsOutline } from "react-icons/io5";
import { api } from "../lib/api";
import { C } from "../lib/theme";

export default function NotificationBell({ testid = "notification-bell" }) {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const pull = async () => {
      try {
        const s = await api.get("/admin/stats");
        if (!cancelled) setCount(Number(s?.feedback_new || 0));
      } catch { /* ignore — bell just stays at last known value */ }
    };
    pull();
    timerRef.current = setInterval(pull, 30000);
    return () => { cancelled = true; if (timerRef.current) clearInterval(timerRef.current); };
  }, []);

  const has = count > 0;
  return (
    <button
      type="button"
      onClick={() => navigate("/admin/feedback")}
      data-testid={testid}
      aria-label={has ? `${count} new feedback messages` : "No new feedback"}
      title={has ? `${count} new feedback message${count === 1 ? "" : "s"}` : "Beta feedback"}
      style={{
        position: "relative",
        width: 40, height: 40, borderRadius: 20,
        background: has ? C.limeTint : "transparent",
        border: `1px solid ${has ? C.lime : C.border}`,
        color: has ? C.lime : C.textMuted,
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        cursor: "pointer", transition: "background-color .15s ease, color .15s ease",
      }}
    >
      {has ? <IoNotifications size={20} /> : <IoNotificationsOutline size={20} />}
      {has && (
        <span
          data-testid={`${testid}-badge`}
          style={{
            position: "absolute", top: -4, right: -4,
            minWidth: 18, height: 18, padding: "0 5px", borderRadius: 9,
            background: C.lime, color: C.onLime,
            fontSize: 10, fontWeight: 800, letterSpacing: 0.3,
            display: "inline-flex", alignItems: "center", justifyContent: "center",
            border: `2px solid ${C.bg}`,
          }}
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
}
